import React from 'react';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';

const ServiceProviders = React.memo(({ isBold }) => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const clearSigninEnabled = useToggleValue(TOGGLE_NAMES.clearSigninEnabled);
  const serviceProviders = clearSigninEnabled
    ? ['ID.me', 'Login.gov', 'CLEAR']
    : ['ID.me', 'Login.gov'];

  return new Intl.ListFormat('en', { style: 'long', type: 'disjunction' })
    .formatToParts(serviceProviders)
    .map(({ type, value }) => {
      if (type === 'element' && value === 'CLEAR') {
        const clear = <span aria-label="Clear">CLEAR</span>;
        return isBold ? <strong>{clear}</strong> : clear;
      }
      return type === 'element' && isBold ? <strong>{value}</strong> : value;
    });
});

export const ServiceProvidersTextCreateAcct = React.memo(
  ({ isFormBased = false, hasExtraTodo = false }) => {
    const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
    const clearSigninEnabled = useToggleValue(TOGGLE_NAMES.clearSigninEnabled);
    const isFormComponent = isFormBased
      ? 'completed this form without signing in, and you '
      : null;
    const showExtraTodo = hasExtraTodo
      ? ` When you sign in or create an account, you’ll be able to:`
      : null;

    return (
      <>
        If you {isFormComponent}
        don’t have any of these accounts, you can create a free{' '}
        {clearSigninEnabled ? (
          <>
            <strong>ID.me</strong>, <strong>Login.gov</strong>, or{' '}
            <strong>
              <span aria-label="Clear">CLEAR</span>
            </strong>
          </>
        ) : (
          <>
            <strong>ID.me</strong> or <strong>Login.gov</strong>
          </>
        )}{' '}
        account now.
        {showExtraTodo}
      </>
    );
  },
);

export default ServiceProviders;
